/** Where a ticket comment was written: in the dashboard, or by answering a service desk email. */
export enum ServiceDeskMessageChannel {
  Dashboard = 0,
  Email = 1,
}
